export default __webpack_public_path__ + "static/media/IMG-20240708-WA0007.e96520e6.jpg";